export const setFilterData = data => ({
  type: 'SET_ACTIVITY_FILTERS',
  data,
});

export const setFilterFlag = data => ({
  type: 'SET_ACTIVITY_FILTER_FLAG',
  data,
});

export const setTag = data => ({
  type: 'SET_TAG',
  data,
});
